export default "__VITE_ASSET__C$ccs7cS__"